import React from 'react';
import PropTypes from 'prop-types';
import './DraftButton.scss';

import Tooltip from '../../General/Tooltip';

const BLOCKED = 'Purpose and Trigger must be filled before an AI draft can be created';

// Draft with AI, wherever words or inputs are missing. Disabled until Purpose and Trigger are
// written, since the draft comes from them, and while any draft is on its way; the tooltip says
// what it does, or why it is waiting.
const DraftButton = ({ onClick, isDrafting = false, isBusy = false, title = '', label = 'Draft with AI' }) => {
  const message = isDrafting
    ? 'Writing the draft now.'
    : isBusy
    ? 'Another draft is on its way; this one can go once it lands.'
    : !onClick
    ? BLOCKED
    : title;
  return (
    <Tooltip outerClassName='draft-button-outer' message={message} position='top'>
      <span className='draft-button-hover'>
        <button
          type='button'
          className='draft-button'
          disabled={!onClick || isDrafting || isBusy}
          onMouseDown={e => e.preventDefault()}
          onClick={e => {
            e.stopPropagation();
            onClick?.();
          }}
        >
          {isDrafting ? 'Drafting…' : label}
        </button>
      </span>
    </Tooltip>
  );
};

DraftButton.propTypes = {
  onClick: PropTypes.func,
  isDrafting: PropTypes.bool,
  isBusy: PropTypes.bool,
  title: PropTypes.string,
  label: PropTypes.string
};

export default DraftButton;
